export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const SHOW_NOTIFICATION_SUCCESS = 'SHOW_NOTIFICATION_SUCCESS';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const FORCE_HIDE_NOTIFICATION = 'FORCE_HIDE_NOTIFICATION';

export const SHOW_STATIC_NOTIFICATION = 'SHOW_STATIC_NOTIFICATION';
export const CLEAR_STATIC_NOTIFICATIONS = 'CLEAR_STATIC_NOTIFICATIONS';
